export const diameter = 44 as const;
